module.exports = __webpack_public_path__ + "img/william-waddel.914e4e2d.jpg";